import {
  Box,
  Button,
  ButtonGroup,
  Container,
  InputAdornment,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { CoinList } from "../config/Api";
import { CryptoState } from "../ContextApi";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { fontWeight } from "@mui/system";
import Carousel, { numberWithCommas } from "./Carousel/Carousel";
import { useNavigate, useParams, Link } from "react-router-dom";
import HomeHeader from "./HomeHeader";
import TopCoins from "./TopCoins";
import CoinChart from "./CoinChart";
import CoinLineChart from "./CoinLineChart";
import SmallChart from "./SmallChart";

const headerMenu = {
  backgroundColor: "rgb(241,243,244)",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  height: 60,
  marginBottom: 20,
};

const buttonStyle = {
  backgroundColor: "",
};

const CoinsTable = ({search}) => {
  const Navigate = useNavigate();
  // let {id}= useParams();
  const [page, setPage] = useState(1);
  const { currency, symbol } = CryptoState();
  const [selectedTab, setSelectedTab] = useState("Coins");

  const tabChange = (event, newAlignment) => {
    setSelectedTab(newAlignment);
  };

  const [coins, setCoins] = useState([]);
  const [sorted, setSorted] = useState({ sorted: "id", reversed: false });
  const [loading, setLoading] = useState(false);

  const fetchCoins = async () => {
    setLoading(true);
    try{
    const { data } = await axios.get(CoinList(currency));
    setCoins(data);
}catch(e){console.log(e)}
    setLoading(false);
  };
  useEffect(() => {
    fetchCoins();
  }, [currency, coins?.id]);
  console.log(coins);


  
  const sortByPrice = () => {
    setSorted({ sorted: "id", reversed: !sorted.reversed });
    const sortedData = coins;
    sortedData.sort((a, b) => {
      if (sorted.reversed) {
        return a.current_price-b.current_price;
      }
      return b.current_price - a.current_price;
    });

    setCoins(sortedData);
  };
  const sortByAge = () => {
    setSorted({ sorted: "age", reversed: !sorted.reversed });
    const sortedData = coins;
    sortedData.sort((a, b) => {
      if (sorted.reversed) {
        return a.age - b.age;
      }
      return b.age - a.age;
    });

    setCoins(sortedData);
  };
  const sortByName = () => {
    setSorted({ sorted: "name", reversed: !sorted.reversed });
    const sortedData = coins;
    sortedData.sort((a, b) => {
      if (sorted.reversed) {
        return b.name.localeCompare(a.name);
      }
      return a.name.localeCompare(b.name);
    });

    setCoins(sortedData);
  };
  const arrow = !sorted.reversed ? <>&uarr;</> : <>&darr;</>; 
  return (
    <>
      {/* <Carousel/>
      <HomeHeader/> */}

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell onClick={sortByName}><span  style={{cursor:"pointer"}}>Coin{sorted.sorted === "name" ? <span> {arrow}</span> : null}</span></TableCell>
              <TableCell  onClick={sortByPrice}><span  style={{cursor:"pointer"}}>Price{sorted.sorted === "id" ? <span> {arrow}</span> : null}</span></TableCell>
              <TableCell>24H Change</TableCell>
              <TableCell>Market Cap</TableCell>
              {/* <TableCell>Last 7 Days</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {coins.filter((item) => {
              return search === "" ? item : item.name.toLowerCase().includes(search.toLowerCase());
            }).slice((page - 1) * 10, (page - 1) * 10 + 10).map((row) => {
              let profit = row.price_change_percentage_24h >= 0;
              return (
                <TableRow
                  key={row.name}
                  onClick={() => Navigate(`/Coins/${row.id}`)}
                  style={{ cursor: "pointer" }}
                >
                  <TableCell
                   
                    style={{
                      display: "flex",
                      gap: 15,
                    }}
                  >
                    <img
                      src={row?.image}
                      alt={row.name}
                      height="50"
                      style={{ marginBottom: 10 }}
                    />
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <span
                        style={{
                          fontSize: 18,
                          fontWeight: 550,
                        }}
                      >
                        {row?.name}
                      </span>
                      <span
                        style={{
                          fontSize: 14,
                        }}
                      >
                        {row?.symbol.toUpperCase()}
                      </span>
                    </div>
                  </TableCell>
                  <TableCell
                    style={{
                      fontWeight: 600,
                    }}
                  >
                    {symbol} {numberWithCommas(row?.current_price.toFixed(2))}
                  </TableCell>
                  <TableCell
                    style={{
                      color: profit > 0 ? "green" : "red",
                      fontWeight: "500",
                    }}
                  >
                    {profit && "+"}{" "}
                    {row?.price_change_percentage_24h?.toFixed(2)}%
                  </TableCell>
                  <TableCell>
                    {symbol}
                    {numberWithCommas(row?.market_cap.toString().slice(0, -6))}M
                  </TableCell>
                  {/* <TableCell>
                   <SmallChart coin={row} inputWidth="120px"/>
                  </TableCell> */}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <Pagination
          onChange={(_, value) => {
            setPage(value);
            window.scroll(0, 390);
          }}
          count={(coins?.length / 10).toFixed(0) || 0}
        />
      </TableContainer>
    </>
  );
};

export default CoinsTable;
